var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultModuleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 0V3H7.14286V0H0V8H7.14286V5H13.4134C12.8236 5.86084 12.5026 6.9149 12.5 8V16C12.4991 16.7953 12.2165 17.5578 11.7144 18.1202C11.2123 18.6825 10.5315 18.9989 9.82143 19H7.14286V16H0V24H7.14286V21H9.82143C11.005 20.9984 12.1397 20.4711 12.9766 19.5338C13.8135 18.5964 14.2843 17.3256 14.2857 16V8C14.2857 7.20487 14.5676 6.44226 15.0693 5.87974C15.5711 5.31722 16.2517 5.0008 16.9616 5H17.8571V8H25V0H17.8571ZM5.35714 6H1.78571V2H5.35714V6ZM5.35714 22H1.78571V18H5.35714V22ZM23.2143 6H19.6429V2H23.2143V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultModuleIcon);
export default __webpack_public_path__ + "static/media/default_module_icon.4431f633df01c3b308ac244a72f90d3f.svg";
export { ForwardRef as ReactComponent };